export enum MissionType {
    EMPTY = 0,
    CLEAR_CARD_HEARTS = -1,
    COLLECT_STARS = -2,
    WIN_LEVEL = -3,
    STREAKS = -4,
    ADD_FRIENDS = -5, // Legacy: It's no longer allowed.
    CLEAR_CARD_CLUBS = -6,
    CLEAR_CARD_SPADES = -7,
    CLEAR_CARD_DIAMONDS = -8,
    CLEAR_CARD_ANY = -9,
    SPIN_WHEEL = -10,
    USE_JOKER = -11,
}

export interface IMissionData {
    type: MissionType;
    target: number;
    progress: number;
    prize: number;
}
